import Cookies from 'js-cookie'
import { isEmpty } from './utils'
import config from 'common/config'
import storage from 'unit/storage'
import sessionStorage from 'unit/sessionStorage'

const key = 'token'

// 获取用户信息
export function getToken() {
    // let token = Cookies.get(key)
    // if (!isEmpty(token)) {
    //     return token
    // }
    return null
}

// 获取企业Token
export function getCompanyToken() {
    // let companyToken = Cookies.get('company_token')
    // if (!isEmpty(companyToken)) {
    //     return companyToken
    // }
    return null
}

export function getCompanyId() {
    return sessionStorage.get('company_id')
}

// 设置用户信息
export function setToken(data) {
    // 设置顶级域
    // Cookies.domain = config.api.host
    return Cookies.set(key, data, { domain: config.api.domain })
}

export function setCompanyToken(data) {
    return Cookies.set('company_token', data, { domain: config.api.domain })
}

export function setStorageCompanyToken(data) {
    sessionStorage.set('company_token', data)
}

export function getStorageCompanyToken() {
    return sessionStorage.get('company_token')
}

// 删除用户信息
export function removeToken() {
    storage.clear()
    sessionStorage.remove('company_token')
    Cookies.set('sevenDay', '', { domain: config.api.domain })
    Cookies.set('companyId', '', { domain: config.api.domain })
    return Cookies.set(key, '', { domain: config.api.domain })
}

export function loadScript() {
    return new Promise(resolve => {
        var script = document.createElement('script')
        let env = config.env === 'deploy' ? '' : `${config.env}.`
        script.src = `//zhst.lingzhuyun.com/openapi/jssdk.v1.0.0.${env}min.js`
        if (window.lz_env && window.lz_env.openapi) {
            script.src = window.lz_env.openapi
        }
        document.getElementsByTagName('head')[0].appendChild(script)
        script.onload = function() {
            resolve()
        }
    })
}
  

// 设置公司ID
export function setCompanyId(val) {
    sessionStorage.set('company_id', val)
}

export function setPreview(data) {
    Cookies.set('preview', JSON.stringify(data), { domain: config.api.domain })
}

export function getPreview() {
    let preview = Cookies.get('preview')
    if (!isEmpty(preview)) {
        return JSON.parse(preview)
    }
    return null
}



// WEBPACK FOOTER //
// ./src/common/auth.js